import { render, staticRenderFns } from "./woocommerce-api-service-manager-item.vue?vue&type=template&id=9784afa4"
import script from "./woocommerce-api-service-manager-item.vue?vue&type=script&lang=js"
export * from "./woocommerce-api-service-manager-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports